import * as React from 'react'
import Select from 'react-select'
import Point from '../../icons/ui/Point'
import { IRiderLocationObject, IServiceLocationObject } from '../../../types'
import { searchLocation, getPlaceDetails } from '../../../utils/location'
import UIMessages from '../../../utils/ui-messages'
import AutoCompleteLocations from '../AutoCompleteLocations'
import DeleteIcon from '../../icons/ui/TrashGrey'
import CharacterCounter from '../../ui/CharacterCounter'
import { Button, Input, Popup } from '@mobiscroll/react-latest'

export interface ILocationItemProps {
  allowToEdit: boolean
  index: number
  location: IRiderLocationObject | IServiceLocationObject
  locations?: IRiderLocationObject[] | IServiceLocationObject[]
  autoCompleteLocations: Array<IRiderLocationObject | IServiceLocationObject>
  onCancel?: () => void
  saveLocation?: (location: IRiderLocationObject | IServiceLocationObject) => void
  showMessage: (error: string, isError: boolean) => void
  updateLocation: (location: IRiderLocationObject | IServiceLocationObject, index: number) => void
  deleteLocation?: (index: number) => void
  openModal?: (location: IRiderLocationObject | IServiceLocationObject, index: number) => void
  searchLocation: (address: string, index: number) => void
  onLocationSelect: (address: string, index?: number) => void
}

interface ILocationItemState {
  errorMsg: string
  isOpen: boolean
  location: any
  isButtonVisible: boolean
  hover: boolean
}

interface IDropdownOption {
  label: string
  value: string
}

const CHARACTER_LIMIT = 25

class LocationItem extends React.Component<ILocationItemProps, ILocationItemState> {
  constructor(props: ILocationItemProps) {
    super(props)
    this.state = {
      errorMsg: '',
      isOpen: false,
      location: { ...this.props.location },
      isButtonVisible: true,
      hover: false
    }
  }

  public componentDidUpdate(prevProps: ILocationItemProps) {
    if (JSON.stringify(this.state.location.coordinates) !== JSON.stringify(this.props.location.coordinates)) {
      this.setState({
        location: { ...this.props.location }
      })
    }
  }

  public render() {
    const { isButtonVisible, location } = this.state
    const { allowToEdit, autoCompleteLocations } = this.props
    const mainStyle: any = {
      pointerEvents: allowToEdit ? 'auto' : 'none',
      opacity: allowToEdit ? 1 : 0.4
    }
    const numOfChar = location.note ? CHARACTER_LIMIT - location.note.length : CHARACTER_LIMIT
    const inputProps = {
      inputStyle: 'box' as const,
      labelStyle: 'floating' as const,
      theme: 'ios',
      type: 'text'
    }

    return (
      <React.Fragment>
        <Popup closeOnOverlayClick={true} display='center' isOpen={this.state.isOpen} onClose={this.closeDeleteModal}>
          <div className='px1 pt1'>
            <div>{UIMessages.common.deleteModalMessage}</div>
            <div className='flex flex-row justify-end pt2'>
              <Button className='mbsc-flat-btn' onClick={this.closeDeleteModal}>
                Cancel
              </Button>
              <Button className='mbsc-danger-btn' onClick={this.onDeleteLocation}>
                Delete
              </Button>
            </div>
          </div>
        </Popup>
        <div
          className={`p2 ${location.isNew && 'bg-light-grey1'} ${this.state.hover && 'bg-light-grey1'}`}
          style={mainStyle}
          onMouseEnter={() => this.setState({ hover: true })}
          onMouseLeave={() => this.setState({ hover: false })}
        >
          <div className='mbsc-grid'>
            <div className='mbsc-row'>
              <div className='mbsc-col-12 mbsc-col-md-6 mbsc-col-lg-5 flex'>
                {this.props.openModal && (
                  <Button className='mbsc-input-start-icon-btn' onClick={this.openModal}>
                    <Point className='svg-blue' />
                  </Button>
                )}
                <div className='w100'>
                  <Input
                    {...inputProps}
                    autoComplete='off'
                    disabled={!!this.props.location.id}
                    label='Location'
                    name='address'
                    placeholder='Add Address'
                    value={location.fullAddress}
                    onChange={this.onAddressChange}
                  />
                </div>
                {!!autoCompleteLocations.length && (
                  <div
                    className='left0 fit flex wrap auto-complete-location absolute bg-light-grey2 flex-wrap items-start cursor--pointer top-30 z1'
                    style={{ top: '55px' }}
                  >
                    {this.props.autoCompleteLocations.map((item: IRiderLocationObject | IServiceLocationObject) => (
                      <AutoCompleteLocations key={item.googlePlaceId} onSelect={this.onLocationSelect} item={item} />
                    ))}
                  </div>
                )}
              </div>
              <div className='mbsc-col-12 mbsc-col-md-6 mbsc-col-lg-2'>
                <Input
                  {...inputProps}
                  label='Place name'
                  name='placeName'
                  placeholder='Add Place Name'
                  value={location.placeName || ''}
                  onChange={this.onInputChange}
                />
              </div>
              <div className='mbsc-col-12 mbsc-col-md-6 mbsc-col-lg-2'>
                <Input
                  {...inputProps}
                  label='Phone number'
                  name='phoneNumber'
                  placeholder='Add Phone Number'
                  value={location.phoneNumber || ''}
                  onChange={this.onInputChange}
                />
              </div>
              <div className='mbsc-col-12 mbsc-col-md-6 mbsc-col-lg-3 flex'>
                <div className='pr2 w100'>
                  <Input
                    {...inputProps}
                    label='Note'
                    maxLength={CHARACTER_LIMIT}
                    name='note'
                    placeholder='Note for provider'
                    value={location.note}
                    onChange={this.onInputChange}
                  />
                  {this.state.errorMsg.length > 0 ? (
                    <div className='flex justify-end pt1'>
                      <span className='ml3 font-small weight-300 font-red'>{this.state.errorMsg}</span>
                    </div>
                  ) : (
                    <CharacterCounter numOfChar={numOfChar} />
                  )}
                </div>
                {this.props.deleteLocation && (
                  <div className='cursor--pointer pt2'>
                    <DeleteIcon className='icon--22x22' onClick={this.openDeleteModal} />
                  </div>
                )}
              </div>
            </div>
            {location.isNew && this.props.saveLocation && (
              <div className='mbsc-row pr2 pt2'>
                <div className='mbsc-col-12 mbsc-col-lg-12'>
                  <div className='flex items-center justify-end'>
                    <Button className='mbsc-flat-white-btn' onClick={this.onCancel}>
                      Cancel
                    </Button>
                    {isButtonVisible && (
                      <Button className='mbsc-success-btn' onClick={this.onSave}>
                        Save
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }

  private clear = () => {
    this.props.showMessage('', false)
    this.setState({ errorMsg: '' })
  }

  private onAddressChange = (event: any) => {
    const address = event.target.value
    this.clear()
    this.setState({
      location: { ...this.state.location, fullAddress: address }
    })
    this.props.searchLocation(address, this.props.index)
  }

  private onLocationSelect = (selectedLocation: any) => () => {
    const location = { ...this.props.location, ...selectedLocation }
    this.props.onLocationSelect(location, this.props.index)
    this.clear()
  }

  private onInputChange = (event: any) => {
    const { location } = this.state
    const { name, value } = event.target

    location[name] = value
    this.clear()
    this.setState({
      location
    })
    this.props.updateLocation(location, this.props.index)

    this.setState({ isButtonVisible: true })
  }

  private openModal = () => {
    if (this.props.openModal) {
      this.props.openModal(this.props.location, this.props.index)
    }
  }

  private onCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel()
    }
    this.clear()
  }

  private onSave = () => {
    const { location } = this.props

    if (this.state.isButtonVisible) {
      this.setState({ isButtonVisible: false })

      if (!location.fullAddress || location.fullAddress.length < 3) {
        this.showErrorMessage(UIMessages.rider.validation.locationAddressMinLength)
        this.setState({ isButtonVisible: true })
        //Enable the button to prevent multiple clicks
        return
      }

      if (this.props.saveLocation) {
        this.props.saveLocation(location)
      }
    }
  }

  private openDeleteModal = () => {
    this.clear()
    this.setState({
      isOpen: true
    })
  }

  private closeDeleteModal = () => {
    this.setState({
      isOpen: false
    })
  }

  private onDeleteLocation = () => {
    if (!this.props.deleteLocation) {
      return
    }

    const { index } = this.props
    this.props.deleteLocation(index)
    this.setState({
      isOpen: false
    })
  }

  private showErrorMessage = (message: string) => {
    this.props.showMessage(message, true)
    this.setState({ errorMsg: message })
  }
}

export default LocationItem



// WEBPACK FOOTER //
// ./src/components/riders/common/LocationItem.tsx